import { render, staticRenderFns } from "./msg-release.vue?vue&type=template&id=00f879a4&scoped=true"
import script from "./msg-release.vue?vue&type=script&lang=js"
export * from "./msg-release.vue?vue&type=script&lang=js"
import style0 from "./msg-release.vue?vue&type=style&index=0&id=00f879a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f879a4",
  null
  
)

export default component.exports